import React from 'react';
import { useEntitlements } from '../hooks/useEntitlements';

interface TierBadgeProps {
    tenantId: string;
}

const TIER_STYLES: Record<string, React.CSSProperties> = {
    free: { backgroundColor: '#e9ecef', color: '#495057', border: '1px solid #ced4da' },
    standard: { backgroundColor: '#cfe2ff', color: '#0a58ca', border: '1px solid #9ec5fe' },
    premium: { backgroundColor: '#fff3cd', color: '#664d03', border: '1px solid #ffda6a' },
};

/**
 * Displays the billing tier of a tenant as a styled badge.
 * Fetches entitlements for the given tenantId.
 */
export default function TierBadge({ tenantId }: TierBadgeProps) {
    const { data: entitlements, isLoading } = useEntitlements(tenantId, true);

    if (isLoading) {
        return (
            <span data-testid={`tier-badge-${tenantId}`} style={{ color: '#6c757d', fontSize: '12px' }}>
                ...
            </span>
        );
    }

    if (!entitlements) {
        return (
            <span data-testid={`tier-badge-${tenantId}`} style={{ color: '#6c757d', fontSize: '12px' }}>
                —
            </span>
        );
    }

    const tier = entitlements.tier;
    const style: React.CSSProperties = {
        display: 'inline-block',
        padding: '0.2rem 0.5rem',
        borderRadius: '0.25rem',
        fontSize: '12px',
        fontWeight: 600,
        textTransform: 'capitalize',
        ...TIER_STYLES[tier],
    };

    return (
        <span data-testid={`tier-badge-${tenantId}`} style={style}>
            {tier}
        </span>
    );
}
